export default "__VITE_ASSET__5e7e22d5__"